import admin_api from '@/api/admin'
import tokenUitl from '@/utils/token'
import { resetRouter } from '@/router'

const admin = {

  state:{
      token: tokenUitl.getToken(),
      name: '',
      avatar: ''
  },
  mutations:{
      SET_TOKEN: (state, token) => {
        state.token = token
      },
      SET_NAME: (state, name) => {
        state.name = name
      },
      SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
      }
  },
  actions:{
    // 用户登录
    login_store({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        admin_api.login(userInfo).then(response => {
          // 设置缓存消息
          commit('SET_TOKEN', response.data.data.token)
          tokenUitl.setToken(response.data.data.token)
          //保存当前登录用户信息
          tokenUitl.setCookiesn('admin',response.data.data.admin)
          resolve(response)  //返回值，不设置 请求页面方法获取不到响应数据
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户退出
    logout_store({commit, state }) {
      return new Promise((resolve, reject) => {
        admin_api.logout(state.token).then(response => {
          commit('SET_TOKEN', '')
          tokenUitl.removeToken() //清除token
          resetRouter()
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 删除token
    resetToken_store({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        tokenUitl.removeToken()
        resolve()
      })
    }
  }

}

export default admin




// WEBPACK FOOTER //
// ./src/store/modules/admin.js